var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-box"},[_c('label',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"field-main"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }